import React from 'react'
import { Navigate } from 'react-router-dom'

export default function PopupRouteGuard({ children }) {
  // During SSR/windowless environments guard against accessing window.
  if (typeof window === 'undefined') return children

  // Allow /auth/popup/next even if opener is missing, so OAuth callback can complete
  if (typeof window !== 'undefined' && window.location.pathname.startsWith('/auth/popup/next')) {
    return children;
  }

  // If there is no opener, the page was opened directly in a browser tab.
  if (window.opener === null) {
    return <Navigate replace to="/" />
  }

  return children
}

